<rcl-header id="error-page-header" [bg]="brandName" [expandable]="false">
  <a id="error-page-header__link" href="" aria-haspopup="true" (click)="goToBrandUrl($event)">
    <img
      id="error-page-header__link-img"
      class="{{ brandName }}-header-logo"
      src="assets/icons/{{ brandName }}-logo.svg"
      alt="{{ brandCorpAltText }} Home"
      />
  </a>
  @if (shouldDisplayMessageCenter && screensize.isdesktop) {
    <rcl-header-extra-option>
      <main-nav-message-center  [messageCenterIcon]="true"></main-nav-message-center>
    </rcl-header-extra-option>
  }
  @if (bundle) {
    <rcl-menu-button
      id="error-page-header__rcl-menu-button"
      [text]="(bundle | async)['user.menu.label.my.account']"
      [expanded]="showMenu"
      (onToggleNav)="toggleShowMenu()">
    </rcl-menu-button>
  }

  @if (!isSafari) {
    <rcl-menu-button-dropdown id="error-page-header__rcl-menu-dropdown">
      <app-user-menu id="error-page-header__rcl-menu-dropdown__user-menu" [(showMenu)]="showMenu" [bundle]="bundle | async" (displayBadgeOnProfileMenu)="displayBadgeOnProfile($event)" [displayMessageCenter]="screensize.isphone && shouldDisplayMessageCenter" [hideMessageCenterContainer]="hideMessageCenterContainer"></app-user-menu>
    </rcl-menu-button-dropdown>
  }
</rcl-header>

@if (isSafari) {
  <app-user-menu id="error-page__user-menu" [(showMenu)]="showMenu" [bundle]="bundle | async" (displayBadgeOnProfileMenu)="displayBadgeOnProfile($event)" [displayMessageCenter]="screensize.isphone && shouldDisplayMessageCenter" [hideMessageCenterContainer]="hideMessageCenterContainer"></app-user-menu>
}

<rcl-main-content id="error-page__main-content">
  <ng-container id="error-page__main-content-container">
    <rcl-system-error id="error-page__main-content-container__system-error">
      @if (bundle) {
        <rcl-system-error-title id="error-page__main-content-container__system-error-title">
          {{ (bundle | async)['error.technical.difficulties.header'] }}
        </rcl-system-error-title>
      }
      <rcl-system-error-description id="error-page__main-content-container__description">
        @if (bundle) {
          <img
            id="error-page__main-content-container__description-img"
            class="error-icon"
            title="System Error"
            alt="{{ (bundle | async)['error.technical.difficulties.subheader'] }}"
            src="assets/icons/system-error-{{ brandName }}.svg"
            />
        }
      </rcl-system-error-description>
    </rcl-system-error>
    <rcl-button-group id="error-page__main-content-container__button-group">
      @if (bundle) {
        <input
          id="error-page__main-content-container__button-group-go-dashboard"
          type="button"
          (click)="goToDashboard()"
          [value]="(bundle | async)['error.technical.difficulties.button.dashboard']"
          class="rcl-button-secondary"
          />
      }
    </rcl-button-group>
  </ng-container>
</rcl-main-content>

@if (shouldDisplayMessageCenter) {
<main-nav-message-center-box></main-nav-message-center-box>
}
